// extracted by mini-css-extract-plugin
module.exports = {"noInfo":"noInfo_noInfo__3Z0OA"};